import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CustomerSampleWrite } from '../../api/strapiCustomerSamples';
import {
  strapiCreateCustomerSampleForCustomer,
  strapiDeleteCustomerSample,
  strapiListCustomerSamplesForCustomer,
  strapiUpdateCustomerSample,
} from '../../api/strapiCustomerSamples';
import { queryKeys } from '../queryKeys';

export function useCustomerSampleLocationsQuery(jwt: string | null, customerDocumentId: string | null) {
  return useQuery({
    queryKey: queryKeys.customerSampleLocations(jwt, customerDocumentId),
    queryFn: () => strapiListCustomerSamplesForCustomer(jwt!, customerDocumentId!),
    enabled: Boolean(jwt && customerDocumentId),
  });
}

export function useCreateCustomerSampleMutation(jwt: string | null, customerDocumentId: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CustomerSampleWrite) =>
      strapiCreateCustomerSampleForCustomer(jwt!, customerDocumentId!, data),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.customerSampleLocations(jwt, customerDocumentId) });
    },
  });
}

export function useUpdateCustomerSampleMutation(jwt: string | null, customerDocumentId: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (args: { documentId: string; data: CustomerSampleWrite }) =>
      strapiUpdateCustomerSample(jwt!, args.documentId, args.data),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.customerSampleLocations(jwt, customerDocumentId) });
    },
  });
}

export function useDeleteCustomerSampleMutation(jwt: string | null, customerDocumentId: string | null) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (documentId: string) => strapiDeleteCustomerSample(jwt!, documentId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.customerSampleLocations(jwt, customerDocumentId) });
    },
  });
}
